/**
 * Rich-text driver factory.
 *
 * Delegates to engine implementations based on `def.engine` (default: 'tiptap').
 * To add a new engine, create a file in `engines/` and register it in the map below.
 */
import * as tiptapEngine from './engines/tiptap-engine.js';

/** @type {Record<string, { mount: (container: HTMLElement, ctx: import('../../../contracts/forms.js').FieldDriverContext) => import('../../../contracts/forms.js').FieldDriverHandle }>} */
const engines = {
  tiptap: tiptapEngine,
};

/** @type {import('../../../contracts/forms.js').FieldDriver} */
export const richTextDriver = {
  type: 'rich-text',
  mount(container, ctx) {
    const rtDef = /** @type {import('../../../contracts/forms.js').RichTextFieldDef} */ (ctx.def);
    const engineName = rtDef.engine ?? 'tiptap';
    const engine = engines[engineName];
    if (!engine) {
      throw new Error(`Unknown rich-text engine: '${engineName}'`);
    }
    return engine.mount(container, ctx);
  },
};
